import { type SidebarEntry } from "@package/ui-config";
import { SidebarNavButton } from "@package/ui-header";
import { useLocation, useNavigate } from "react-router";

export function SidebarMenuItem({ entry }: { entry: SidebarEntry }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const path = `/${entry.path}`;

  return (
    <SidebarNavButton
      icon={entry.icon}
      text={entry.text}
      active={!!pathname?.startsWith(path)}
      onClick={() => navigate(path + search)}
    />
  );
}
